import React from "react";
import { Modal, Button } from "reactstrap";
import { handlePostRequest } from "../../helpers/handle-response";
import { formatCurrency } from "../../helpers/functions";

const DeleteModal = ({ open, setOpen, rowToDelete, deleteStroj }) => {
  return (
    <Modal
      className="modal-dialog-centered"
      size={"lg"}
      isOpen={open.Delete}
      toggle={() => setOpen({ ...open, Delete: !open.Delete })}
    >
      <div className="modal-header">
        <h3 className="modal-title" id="exampleModalLabel">
          Obriši unos
        </h3>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setOpen({ ...open, Delete: !open.Delete })}
        >
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="mx-auto">
        <h2 className="ml-4 ml-sm-0">Jeste li sigurni da želite obrisati unos troškovnika?</h2>
        <ul>
          <li>
            Stavka:{" "}
            <span className="font-weight-bold"> {rowToDelete.Stavka}</span>
          </li>
          <li>
            Struka:{" "}
            <span className="font-weight-bold"> {rowToDelete.Struka}</span>
          </li>
          <li>
            Opis: <span className="font-weight-bold"> {rowToDelete.Opis}</span>
          </li>
          <li>
            Jedinična mjera:{" "}
            <span className="font-weight-bold">
              {" "}
              {rowToDelete.JedinicnaMjera}
            </span>
          </li>
          <li>
            Količina ukupno:{" "}
            <span className="font-weight-bold">
              {" "}
              {rowToDelete.KolicinaUkupno}
            </span>
          </li>
          <li>
            Jedinična cijena:{" "}
            <span className="font-weight-bold">
              {" "}
              {formatCurrency(rowToDelete.JedinicnaCijena)} HRK
            </span>
          </li>
          <li>
            Ukupna cijena:{" "}
            <span className="font-weight-bold">
              {" "}
              {formatCurrency(rowToDelete.UkupnaCijena)} HRK
            </span>
          </li>
        </ul>
        <Button
          className="mx-auto my-2 d-flex"
          color="danger"
          onClick={deleteStroj}
        >
          Obriši
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
